import React from "react";

/**
 * Título de página para mobile.
 *
 * El header superior mobile pasó a ser transparente y SIN título (estilo
 * Interfaz V2, solo botones redondos flotantes). Donde hace falta orientar al
 * usuario, el título vive dentro de la página, arriba de todo, left-aligned.
 *
 * Se muestra SOLO en mobile (`sm:hidden`) porque en desktop cada página ya
 * tiene su propio header `hidden sm:flex`. Encapsula tipografía + espaciado
 * para que todas las pantallas queden EXACTAMENTE iguales.
 *
 * `accion` es el lugar para el control de la derecha (Configuración en "Marca").
 * Va acá y no `absolute` en cada pantalla —como estaba— por dos motivos: en la
 * misma fila, alinearlo con el título es `items-center` y no un `top` calculado a
 * mano; y como la fila entera es `sm:hidden`, el botón se va con el título en vez
 * de quedar flotando solo entre 640 y 768px, donde el título ya no se dibuja.
 */
export const MobilePageTitle = ({
  children,
  accion,
}: {
  children: React.ReactNode;
  accion?: React.ReactNode;
}) => (
  <div className="sm:hidden mb-4 flex items-center justify-between gap-3">
    <h1 className="pl-2 text-[26px] leading-tight font-semibold tracking-[-0.01em] text-brand-black">
      {children}
    </h1>
    {accion}
  </div>
);
